import { styled, Theme } from '@material-ui/core';

export const NotificationsItemImg = styled('img')<Theme>(({ theme }) => ({
  width: '100%',
  height: 'auto',
  aspectRatio: '16/9',
  objectFit: 'cover',
  cursor: 'pointer',
}));
